<div class='complexity-container'>
  <div class='complexity-bar-container'>
    @switch (score) {
      @case (0) {
        <div class='complexity-bar score-0'></div>
      }
      @case (1) {
        <div class='complexity-bar score-1'></div>
      }
      @case (2) {
        <div class='complexity-bar score-2'></div>
      }
      @case (3) {
        <div class='complexity-bar score-3'></div>
      }
      @case (4) {
        <div class='complexity-bar score-4'></div>
      }
    }
  </div>
  <div class='complexity-labels' fxLayout='row' fxLayoutAlign="space-between stretch">
    <div>Weak</div>
    <div>Strong</div>
  </div>
  @if (warning !== "") {
    <div>
      <span>Warning: {{ warning }}</span>
    </div>
  }

  @if (suggestions.length > 0) {
    @for (suggestion of suggestions; track suggestion) {
      <div>{{suggestion}}</div>
    }
  }
</div>
